module.exports = __webpack_public_path__ + "img/Lavish1.63429a7f.jpg";